module.exports = __webpack_public_path__ + "img/Z61Q_06.068c9a3c.jpg";